const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRICES)

export const apiDietPrices = {
	updateDietPrice: async (payload: IDietPricesPayload[]) => {
		await apiCommon(`${groupPrefix}`, { method: 'POST', body: { prices: payload } })
	},
}
